module.exports = __webpack_public_path__ + "images/enable-favorites-a36ed69749fdc8e25a78da1ce1b78489.jpg";